import { render } from "./CustomAreaManagerBulk.vue?vue&type=template&id=5cf633e4"
import script from "./CustomAreaManagerBulk.vue?vue&type=script&lang=js"
export * from "./CustomAreaManagerBulk.vue?vue&type=script&lang=js"

import "./CustomAreaManagerBulk.vue?vue&type=style&index=0&id=5cf633e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__